<!--  媒体授权-->
<template>
  <div class="media-tab">
    <a-button
      type="primary"
      class="bind-btn"
      @click="handleBindAccount"
    >关联账号</a-button>
    <div class="page-table">
      <a-table
        :columns="mainColumns"
        :dataSource="mainTableList.data"
        rowKey="id"
        size="small"
        :pagination="mainTableList.pagination"
        :loading="mainTableList.loading"
        @change="
          p => {
            mainTableList.pagination = p;
            getMainTableList(p.current);
          }
        "
        :customRow="customRowFn"
        :rowClassName="tableRowClassFn"
      />
    </div>

    <!-- facebook 特殊表格 -->
    <div v-if="tabData.platform === 1" key="facebook-table" style="padding: 0 20px;">
      <a-row class="batch-action mb-10">
        <div class="title fl ml-30 mcc">
          【BM账号管理】-
          <span v-if="breadcrumbList.length" class="mr-5">
            {{ breadcrumbList[0].descriptiveName || breadcrumbList[0].name }}
          </span>
          <div>
            <a-button size="small" class="update-mcc-btn ml-20" @click="getSynFacebookBm()" v-if="!isBmMccLoading">
              <icon-font type="icon-Reload" class="mr-10"></icon-font>刷新BM
            </a-button>
            <a-button v-else size="small" class="update-mcc-btn update-loading ml-20" disabled>
              <img src="@/assets/images/icons/refresh-loading.gif" class="mr-5" />
              正在同步BM
            </a-button>
          </div>
          <span class="update-time ml-10" v-show="lastSyncTime">上次刷新时间：{{ lastSyncTime }}</span>
        </div>
        <div class="search-wrap fr mr-30">
          <a-input-search
            placeholder="请输入账号名称/账号ID"
            v-model.trim="searchForm"
            @search="handleBmAccountSearch"
            allow-clear
            style="width: 260px"
          >
            <a-button slot="enterButton">
              <icon-font type="icon-Search" class="fs-20"></icon-font>
            </a-button>
          </a-input-search>
        </div>
      </a-row>

      <div class="bm-account-box">
        <a-row v-if="$isEmpty(searchParams)">
          <a-col span="8" style="border-right: 1px solid #ECEFF7">
            <div class="bm-list-card">
              <a-spin :spinning="bmListLoading">
                <a-list item-layout="horizontal" :data-source="BMList">
                  <a-list-item
                    slot="renderItem"
                    slot-scope="item"
                    :class="currentSeletedBm.fbBusinessesId === item.fbBusinessesId ? 'selected' : ''"
                    @click="selectBM(item)"
                  >
                    <a-list-item-meta>
                      <span slot="title">{{ item.fbBusinessesUser }}</span>
                      <a-avatar slot="avatar" :src="item.role === 'ADMIN' ? adminAvatar : employeeAvatar" />
                    </a-list-item-meta>
                    <div class="role">
                      {{ item.role === "ADMIN" ? "管理员" : "普通成员" }}
                    </div>
                  </a-list-item>
                </a-list>
              </a-spin>
            </div>
          </a-col>
          <a-col span="16">
            <div class="bm-account">
              <div class="bm-bar">
                <span v-if="currentSeletedBm">
                  <a-avatar slot="avatar" :src="currentSeletedBm.role === 'ADMIN' ? adminAvatar : employeeAvatar" />
                  <span class="account">{{ currentSeletedBm.fbBusinessesUser }}</span>
                  <span class="role">
                    {{ currentSeletedBm.role === "ADMIN" ? "管理员" : "普通成员" }}
                  </span>
                </span>
              </div>
              <div class="table-content table-wrap">
                <h4>账号列表</h4>
                <div class="table-wrap">
                  <a-table
                    :columns="columns_bm_inner"
                    :dataSource="detailTableList.data"
                    :pagination="detailTableList.pagination"
                    :loading="detailTableList.loading"
                    size="small"
                    @change="
                      p => {
                        detailTableList.pagination = p;
                        getBmAccountList(p.current);
                      }
                    "
                    rowKey="fbAccountId"
                    :scroll="{ y: 180 }"
                  />
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row class="table-wrap search-result-box" v-else>
          <p class="line">{{ `以下是搜索“${searchParams}”的账号结果` }}</p>
          <a-table
            :columns="columns_bm_inner_search"
            :dataSource="detailTableList.data"
            :pagination="detailTableList.pagination"
            :loading="detailTableList.loading"
            size="small"
            @change="
              p => {
                detailTableList.pagination = p;
                getBmAccountList(p.current);
              }
            "
            rowKey="fbAccountId"
            bordered
            :scroll="{ y: 270 }"
          />
        </a-row>
      </div>
    </div>

    <!-- google 特殊表格 -->
    <div v-else-if="tabData.platform === 2" key="google-table" style="padding: 0 20px;">
      <a-row class="batch-action mb-10">
        <div class="title fl ml-30 mcc">
          <span>【MCC账号管理】-</span>
          <span v-if="breadcrumbList.length" class="ml-5">
            {{ breadcrumbList[0].descriptiveName || breadcrumbList[0].name }}
          </span>
          <div>
            <a-button size="small" class="update-mcc-btn ml-20" @click="getSynGoogleMcc()" v-if="!isBmMccLoading">
              <icon-font type="icon-Reload" class="mr-10"></icon-font>刷新mcc
            </a-button>
            <a-button v-else size="small" class="update-mcc-btn update-loading ml-20" disabled>
              <img src="@/assets/images/icons/refresh-loading.gif" class="mr-5" />
              正在同步mcc
            </a-button>
          </div>
          <span class="update-time ml-10" v-show="lastSyncTime"> 上次刷新时间：{{ lastSyncTime }} </span>
        </div>
        <a-row class="mcc-search fr">
          <div class="search-wrap">
            <a-input-search
              placeholder="请输入MCC ID/名称"
              v-model="searchMccForm"
              @search="handleMccSearch"
              allow-clear
              style="width: 260px"
            >
              <a-button slot="enterButton">
                <icon-font type="icon-Search" class="fs-20"></icon-font>
              </a-button>
            </a-input-search>
          </div>
        </a-row>
      </a-row>

      <a-row class="table-advertiser">
        <!-- google MCC Table -->
        <a-row>
          <div class="table-wrap">
            <a-table
              :columns="columns_mcc"
              :scroll="{ x: 1000 }"
              :dataSource="mccTableList.data"
              :pagination="mccTableList.pagination"
              :loading="mccTableList.loading"
              @change="handlePageChange"
              rowKey="customerId"
              :expandIcon="expandIcon"
              :expandIconAsCell="false"
              :expandIconColumnIndex="6"
              :expandedRowKeys="mccExpandedRowKeys"
              @expand="mccExpand"
              size="small"
              :row-selection="{
                onChange: handleSelectChange,
                selectedRowKeys,
                getCheckboxProps: record => ({
                  props: { disabled: record.authStatus !== 0 }
                })
              }"
            >
              <div slot="expandedRowRender" class="inner-box">
                <a-row class="batch-action inner-search">
                  <div class="search-wrap">
                    <a-input-search
                      placeholder="请输入广告账号ID/名称"
                      v-model="searchForm"
                      @search="handleMccInnerSearch"
                      allow-clear
                      style="width: 260px"
                    >
                      <a-button slot="enterButton">
                        <icon-font type="icon-Search" class="fs-20"></icon-font>
                      </a-button>
                    </a-input-search>
                  </div>
                </a-row>
                <a-row class="mcc-table-inner">
                  <a-table
                    :columns="columns_mcc_inner"
                    :dataSource="detailTableList.data"
                    :pagination="detailTableList.pagination"
                    :loading="detailTableList.loading"
                    @change="
                      p => {
                        detailTableList.pagination = p;
                        getMccAccountList(p.current);
                      }
                    "
                    size="small"
                    rowKey="customerId"
                    :scroll="{ y: 280 }"
                  />
                </a-row>
              </div>
            </a-table>
          </div>
        </a-row>
      </a-row>
    </div>

    <!-- 通用子表 -->
    <div v-else-if="[4, 9].includes(tabData.platform)" style="padding: 0 20px;">
      <a-row class="batch-action mb-10">
        <div class="title fl ml-30 mcc">
          <span>账号管理</span>
          <span class="update-time ml-10" v-show="lastSyncTime"> 上次刷新时间：{{ lastSyncTime }} </span>
        </div>
        <a-row class="fr mcc-search">
          <div class="search-wrap">
            <a-input-search
              :placeholder="tabData.platform === 9 ? '请输入 XID/名称' : '请输入账号 ID/名称'"
              v-model="searchForm"
              @search="handleDetailSearch"
              allow-clear
              style="width: 260px"
            >
              <a-button slot="enterButton">
                <icon-font type="icon-Search" class="fs-20"></icon-font>
              </a-button>
            </a-input-search>
          </div>
        </a-row>
      </a-row>
      <a-row class="table-advertiser">
        <div class="table-wrap">
          <a-table
            :columns="detailColumns"
            :dataSource="detailTableList.data"
            :pagination="detailTableList.pagination"
            :loading="detailTableList.loading"
            @change="
              p => {
                detailTableList.pagination = p;
                getDetailTableList(p.current);
              }
            "
            rowKey="fbAccountId"
            size="small"
          />
        </div>
      </a-row>
    </div>

    <!-- 授权Yeahmobi管理 -->
    <!-- <TipGgAuthModal ref="tipGgAuthModal" />

    <AccountBoundModal ref="accountBoundModal" :data="googleAccountData" />

    <AccountUnboundStepTwo
      ref="accountUnboundStepTwo"
      :data="googleAccountData"
      :parentName="parentName"
      @back="handleBindPrevious"
    /> -->
  </div>
</template>
<script>
// import TipGgAuthModal from "./tipGgAuthModal.vue";
// import AccountUnboundStepTwo from "./accountUnboundStepTwo.vue";

import {
  mediaOAuthBindPath,
  synGoogleMcc,
  synGoogleMccTime,
  pageBmOfUser,
  fbPageAccountOfBm,
  fbSynBM,
  getBmSynTime,
  getGoogleMcc,
  ggAccountOfMcc,
  mediaOAuthUnbind,
  getMediaUserInfo,
  pageAccount,
} from "@/api/mediadata";

import adminAvatar from "@/assets/images/icons/admin.svg";
import employeeAvatar from "@/assets/images/icons/employee.svg";

export default {
  name: 'MediaTab',
  components: {
    // TipGgAuthModal,
    // AccountUnboundStepTwo
  },
  props: {
    tabData: Object
  },
  data() {
    return {
      adminAvatar,
      employeeAvatar,

      breadcrumbList: [],
      isBmMccLoading: false, // icon loading
      searchForm: "", // 子表 输入参数
      searchParams: "", // 子表 查询参数
      lastSyncTime: null, // 刷新时间

      /**
       * @description: facebook字段
       * @param {*}
       * @return {*}
       */

      BMList: [],
      currentSeletedBm: {},
      bmListLoading: false,

      /**
       * @description: google字段
       * @param {*}
       * @return {*}
       */
      searchMccForm: "",
      searchMccParams: "",
      currentSelectedMcc: {},
      mccExpandedRowKeys: [], // googel 子表 展开
      googleAccountData: null,
      parentName: "",

      // 主表
      mainTableList: {
        loading: false,
        data: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          size: "small",
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "200"],
          buildOptionText: size => {
            return `${size.value}条/页`;
          },
          showTotal: function(total) {
            return `共${total}条`;
          }
        }
      },
      selectRow: {}, // 选中行

      detailTableList: {
        loading: false,
        data: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          size: "small",
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "200"],
          buildOptionText: size => {
            return `${size.value}条/页`;
          },
          showTotal: function(total) {
            return `共${total}条`;
          }
        }
      },
      // google MCC Table
      mccTableList: {
        loading: false,
        data: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10,
          size: "small",
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "200"],
          buildOptionText: size => {
            return `${size.value}条/页`;
          },
          showTotal: function(total) {
            return `共${total}条`;
          }
        }
      },

      // 无用的字段
      selectedRowKeys: [],
      openAccountModalType: "",
      contractList: [],
      openAccountModalParams: {},
      settlementInfoModalData: {
        channelList: [],
        contractList: []
      },
      bindBmModalData: [],
      recordListModalData: {},
      rechargeModalData: {},
      mccSelectRow: []
    };
  },
  computed: {
    // 主表列
    mainColumns() {
      const _this = this;
      const column = [
        {
          key: "name",
          dataIndex: "name",
          title: "账户名称",
          width: 250
        },
        {
          title: "账户ID",
          dataIndex: "userId",
          key: "userId",
          width: 200
        },
        {
          title: "邮箱",
          dataIndex: "email",
          key: "email",
          width: 200
        },
        {
          visible: ![9].includes(_this.tabData.platform),
          title: "授权状态",
          dataIndex: "status",
          key: "status",
          width: 150,
          customRender: () => {
            return (
              <div class="flex flex-column-center">
                <span class="status-dot status-success-dot"></span>
                <a href="javascript:void(0)" style="color:#42C798">
                  正常
                </a>
              </div>
            );
          }
        },
        {
          visible: ![9].includes(_this.tabData.platform),
          title: "上次授权时间",
          key: "updateTime",
          dataIndex: "updateTime",
          width: 200
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          // scopedSlots: { customRender: "action" },
          width: 100,
          customRender: (text, record) => {
            const events = { on: {} };
            events.on.confirm = () => {
              // console.warn(record);
              _this.handleUnbind(record);
            };
            return (
              <a-popconfirm title="您确定要取消授权吗？" okText="解绑" cancelText="取消" placement="right" {...events}>
                <div
                  on-click={e => {
                    e.stopPropagation();
                  }}
                  style="text-align: left;color:#22ac35;cursor:pointer;">
                  <icon-font type="iconjiechubangding" class="fs-16" name="充值" />
                  解绑
                </div>
              </a-popconfirm>
            );
          }
        }
      ];
      return column.filter(t => {
        /* eslint-disable */
        return t.hasOwnProperty("visible") ? t.visible : true;
      });
    },
    // 通用附表 列
    detailColumns() {
      const _this = this;
      const column = [
        {
          title: _this.tabData.platform === 9 ? "XID" : "账号ID",
          key: "accountId",
          dataIndex: "accountId",
          width: 250
        },
        {
          title: _this.tabData.platform === 9 ? "XID名称" : "账号名称",
          dataIndex: "accountName",
          key: "accountName",
          width: 200
        },
        // {
        //   visible: [4].includes(_this.tabData.platform),
        //   title: "余额",
        //   dataIndex: "balance",
        //   key: "balance",
        //   width: 200
        // },
        {
          title: "币种",
          dataIndex: "currency",
          key: "currency",
          width: 200
        },
        {
          title: "时区",
          key: "timezone",
          dataIndex: "timezone",
          width: 180
        }
      ];
      return column.filter(t => {
        /* eslint-disable */
        return t.hasOwnProperty("visible") ? t.visible : true;
      });
    },
    // facebook 详情表1
    columns_bm_inner() {
      const _this = this;
      return [
        {
          title: "账号名称",
          dataIndex: "name",
          key: "name",
          width: 220
        },
        {
          title: "账号ID",
          dataIndex: "fbAccountId",
          key: "fbAccountId"
        },
        {
          title: "币种",
          dataIndex: "currency",
          key: "currency",
          width: 180
        },
        {
          title: "时区",
          key: "timeZone",
          dataIndex: "timeZone",
          width: 180,
          customRender: (text, record) => {
            if (_this.$isEmpty(record.timeZone)) {
              return "--";
            }
            return (
              <div>
                ({record.timeZoneOffset})
                <br />
                {record.timeZone}
              </div>
            );
          }
        }
      ];
    },
    // facebook 详情表2
    columns_bm_inner_search() {
      const _this = this;
      return [
        {
          title: "BM",
          dataIndex: "ownerBMs",
          key: "ownerBMs",
          width: 280,
          customRender: (text, record) => {
            if (_this.$isEmpty(record.ownerBMs)) {
              return "--";
            }
            return (
              <div style="display:flex">
                <div class="table-cell-bm">
                  {record.ownerBMs.map(bm => (
                    <span>
                      {bm.businessId}
                      {bm.role === "ADMIN" ? (
                        <a-tag color="#FFF7E2">
                          <span style="color:#F3BE3C">管理员</span>
                        </a-tag>
                      ) : (
                        <a-tag color="#ECEFF7">
                          <span style="color:#94AAC3">普通成员</span>
                        </a-tag>
                      )}
                    </span>
                  ))}
                </div>
                <a-popover placement="right" overlayClassName="bm-popover">
                  <template slot="content">
                    {record.ownerBMs.map(bm => (
                      <span class="bm-tag-box">
                        {bm.businessId}
                        {bm.role === "ADMIN" ? (
                          <a-tag color="#FFF7E2">
                            <span style="color:#F3BE3C">管理员</span>
                          </a-tag>
                        ) : (
                          <a-tag color="#ECEFF7">
                            <span style="color:#94AAC3">普通成员</span>
                          </a-tag>
                        )}
                      </span>
                    ))}
                  </template>
                  <span class="more-btn c-green">
                    <icon-font type="iconmore" />
                  </span>
                </a-popover>
              </div>
            );
          }
        },
        ..._this.columns_bm_inner
      ];
    },
    // google 详情表1
    columns_mcc() {
      const _this = this;
      return [
        {
          title: "MCC名称",
          dataIndex: "descriptiveName",
          key: "descriptiveName",
          width: 250
        },
        {
          title: "MCC ID",
          dataIndex: "customerId",
          key: "customerId",
          width: 160
        },
        {
          title: "上级MCC ID",
          dataIndex: "parentId",
          key: "parentId",
          scopedSlots: { customRender: "parentId" },
          width: 160,
          customRender: (text, record) => {
            if (_this.$isEmpty(record.parentId)) {
              return "无";
            }
            return <a on-click={() => _this.handleParentMccSearch(record.parentId)}>{record.parentId}</a>;
          }
        },
        {
          title: "币种",
          dataIndex: "currencyCode",
          key: "currencyCode",
          width: 80
        },
        {
          title: "时区",
          key: "timeZone",
          dataIndex: "timeZone",
          width: 180,
          customRender: (text, record) => {
            if (_this.$isEmpty(record.timeZone)) {
              return "--";
            }
            return (
              <div>
                ({record.timeZoneOffset})
                <br />
                {record.timeZone}
              </div>
            );
          }
        },
        {
          title: "",
          key: "expandIcon",
          dataIndex: "expandIcon",
          width: 80
        }
      ];
    },
    // google 详情表2
    columns_mcc_inner() {
      const _this = this;
      return [
        {
          title: "广告账号名称",
          dataIndex: "descriptiveName",
          key: "descriptiveName",
          width: 250
        },
        {
          title: "广告账号ID",
          dataIndex: "customerId",
          key: "customerId",
          width: 225
        },
        {
          title: "币种",
          dataIndex: "currencyCode",
          key: "currencyCode",
          width: 180
        },
        {
          title: "时区",
          key: "timeZone",
          dataIndex: "timeZone",
          width: 180,
          customRender: (text, record) => {
            if (_this.$isEmpty(record.timeZone)) {
              return "--";
            }
            return (
              <div>
                ({record.timeZoneOffset})
                <br />
                {record.timeZone}
              </div>
            );
          }
        },
      ];
    }
  },
  methods: {
    handleSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.mccSelectRow = selectedRows;
    },
    // tabs 切换
    resetPage() {
      this.mainTableList.data = [];
      this.mainTableList.pagination.total = 0;
      this.mainTableList.pagination.current = 1;

      this.detailTableList.data = [];
      this.detailTableList.pagination.total = 0;
      this.detailTableList.pagination.current = 1;

      this.selectRow = {};
      this.breadcrumbList = [];
      this.lastSyncTime = null;
      this.searchForm = ""; // 子表 输入参数
      this.searchParams = ""; // 子表 查询参数
      this.searchMccForm = ""; // 子表 输入参数
      this.searchMccParams = ""; // 子表 查询参数

      this.mccTableList.data = [];
      this.mccTableList.pagination.total = 0;
      this.mccTableList.pagination.current = 1;
      this.getMainTableList();
    },
    tableRowClassFn: function(record, index) {
      return record.id === this.selectRow.id ? "row-selected" : "";
    },
    customRowFn(row, index) {
      return {
        on: {
          // 事件
          click: event => {
            // console.warn(row)
            this.selectRow = row;
            this.breadcrumbList = row ? [row] : [];

            if (row) {
              // 获取bm或mcc
              if (this.tabData.platform === 1) {
                this.getFacebookBmInfos();
                this.isBmMccLoading = false;
                this.getSynFacebookBmTime();
              } else if (this.tabData.platform === 2) {
                this.getGoogleMccList();
                this.isBmMccLoading = false;
                this.getSynGoogleMccTime();
              } else if ([4, 9].includes(this.tabData.platform)) {
                this.handleDetailSearch();
              }
            }
          }
        }
      };
    },
    // 添加账号
    handleBindAccount() {
      mediaOAuthBindPath({
        mediaCode: this.tabData.code
      }).then((res) => {
        window.open(res.data)
      }).finally(() => this.loading = false)
    },
    handlePageChange(val) {
      this.mccTableList.pagination = val;
      this.getGoogleMccList(val.current);
    },
    /**
     * @description: 主表查询接口
     * @param {*} page
     * @return {*}
     */
    async getMainTableList(page = 1) {
      try {
        this.mainTableList.pagination.current = page;
        const params = {
          pageNo: this.mainTableList.pagination.current,
          pageSize: this.mainTableList.pagination.pageSize,
          urlName: this.tabData.urlName
        };
        this.mainTableList.loading = true;

        const res = await getMediaUserInfo(params);

        if (this.$isEmpty(res.data.recordList)) {
          throw new Error("数据为空，无需执行");
        }

        if ([1, 2, 4, 9].includes(this.tabData.platform)) {
          // 默认选中第一行数据
          setTimeout(() => {
            this.customRowFn(res.data.recordList[0]).on.click();
          }, 100);
        }

        this.mainTableList.data = res.data.recordList;
        this.mainTableList.pagination.total = res.data.recordCount;
      } catch (error) {
        console.log(error)
        this.mainTableList.data = [];
        this.mainTableList.pagination.total = 0;
      }
      this.mainTableList.loading = false;
    },
    // 通用子表查询
    handleDetailSearch() {
      this.lastSyncTime = new Date().toLocaleString().replace(/[0-9:]{5}$/g, "00:00");
      this.searchParams = this.searchForm;
      this.getDetailTableList(1);
    },
    // 通用子表 翻页
    async getDetailTableList(page = 1) {
      try {
        if (this.$isEmpty(this.selectRow.userId)) {
          return;
        }
        const params = {
          platform: this.tabData.platform,
          userId: this.selectRow.userId,
          urlName: this.tabData.urlName,
          pageNo: page,
          pageSize: this.detailTableList.pagination.pageSize
        };
        if (!this.$isEmpty(this.searchParams)) {
          params["searchKeyWord"] = this.searchParams;
        }
        this.detailTableList.loading = true;
        const res = await pageAccount(params);
        this.detailTableList.data = res.data ? res.data.recordList : [];
        this.detailTableList.pagination.total = res.data.recordCount;
        this.detailTableList.pagination.current = res.data.current;
        this.detailTableList.loading = false;
      } catch (error) {
        this.detailTableList.data = [];
        this.detailTableList.pagination.total = 0;
        this.detailTableList.pagination.current = page;
        this.detailTableList.loading = false;
      }
    },
    // 解绑操作
    async handleUnbind(data) {
      const res = await mediaOAuthUnbind({
        id: data.id,
        mediaCode: this.tabData.code,
      });

      if (res.code === 200) {
        this.$message.success("解绑成功！");
        this.resetPage();
      }
    },

    /**
     * @description: 以下facebook 方法
     * @param {*}
     * @return {*}
     */
    // BM账号 刷新
    async getSynFacebookBm() {
      if (this.selectRow.userId) {
        this.isBmMccLoading = true;
        try {
          const params = {
            userId: this.selectRow.userId
          };
          await fbSynBM(params);
          this.isBmMccLoading = false;
          this.$message.success("同步成功！");
          this.getSynFacebookBmTime();
          this.getFacebookBmInfos();
        } catch (error) {
          this.isBmMccLoading = false;
        }
      }
    },
    /**
     * @description: 获取BM 上次刷新时间
     * @param {*}
     * @return {*}
     */
    async getSynFacebookBmTime() {
      try {
        const params = {
          userId: this.selectRow.userId
        };
        const res = await getBmSynTime(params);
        this.lastSyncTime = res.data;
      } catch (error) {
        this.lastSyncTime = null;
      }
    },
    // 获取BM 左侧表格
    async getFacebookBmInfos() {
      if (this.selectRow.userId) {
        const params = {
          userId: this.selectRow.userId,
          pageNo: 1,
          pageSize: 9999
        };
        this.bmListLoading = true;
        const res = await pageBmOfUser(params);
        this.bmListLoading = false;
        this.BMList = res.data.recordList || [];
        this.currentSeletedBm = this.BMList[0];
        if (this.currentSeletedBm) {
          this.getBmAccountList();
        } else {
          this.detailTableList.data = [];
        }
      }
    },
    // 子表查询 按钮
    handleBmAccountSearch() {
      this.searchParams = this.searchForm;
      this.getBmAccountList();
    },
    selectBM(bm) {
      this.currentSeletedBm = bm;
      this.getBmAccountList();
    },
    // 获取BM 详情数据
    async getBmAccountList(page = 1) {
      const params = {
        userId: this.selectRow.userId,
        pageNo: page,
        pageSize: this.detailTableList.pagination.pageSize,
        bmOrMcc: this.currentSeletedBm.fbBusinessesId
      };
      if (!this.$isEmpty(this.searchParams)) {
        params["searchKeyWord"] = this.searchParams;
      }
      this.detailTableList.loading = true;
      const res = await fbPageAccountOfBm(params);
      this.detailTableList.data = res.data ? res.data.recordList : [];
      this.detailTableList.pagination.total = res.data.recordCount;
      this.detailTableList.pagination.current = res.data.pageNo;
      this.detailTableList.loading = false;
    },
    // 获取MCC 上次刷新时间
    async getSynGoogleMccTime() {
      try {
        const params = {
          ggUserId: this.selectRow.userId
        };
        const res = await synGoogleMccTime(params);
        this.lastSyncTime = res.data;
      } catch (error) {
        this.lastSyncTime = null;
      }
    },
    // 刷新mcc
    async getSynGoogleMcc(page = 1) {
      if (this.selectRow.userId) {
        this.isBmMccLoading = true;
        try {
          const params = {
            ggUserId: this.selectRow.userId
          };
          await synGoogleMcc(params);
          this.isBmMccLoading = false;
          this.$message.success("同步成功！");
          this.getSynGoogleMccTime();
          this.getGoogleMccList(page);
        } catch (error) {
          this.isBmMccLoading = false;
        }
      }
    },

    /**
     * @description: google 子表中 parentId查询
     * @param {*} parentId
     * @return {*}
     */
    handleParentMccSearch(parentId) {
      this.searchMccForm = parentId;
      this.handleMccSearch();
    },
    // google 子表 查询
    handleMccSearch() {
      this.searchMccParams = this.searchMccForm;
      this.searchParams = "";
      this.searchForm = "";
      this.mccExpandedRowKeys = [];
      this.getGoogleMccList();
    },
    async getGoogleMccList(page = 1) {
      if (this.selectRow.userId) {
        const params = {
          userId: this.selectRow.userId,
          pageNo: page,
          pageSize: this.mccTableList.pagination.pageSize
        };
        if (this.searchMccParams) {
          params["searchKeyWord"] = this.searchMccParams;
        }
        this.mccTableList.loading = true;
        const res = await getGoogleMcc(params);
        this.mccTableList.data = !!res.data && !!res.data.recordList ? res.data.recordList : [];
        this.mccTableList.pagination.total = res.data.recordCount;
        this.mccTableList.pagination.current = res.data.pageNo;
        this.mccTableList.loading = false;
      }
    },

    mccExpand(expanded, record) {
      this.parentName = record.descriptiveName;
      if (expanded) {
        // 当前展开时关闭其他已展开的
        this.mccExpandedRowKeys = [record.customerId];
        this.currentSelectedMcc = record;
        this.getMccAccountList();
      } else {
        this.mccExpandedRowKeys = [];
      }
    },

    /**
     * @description: google子表中 子表 查询按钮
     * @param {*} page
     * @return {*}
     */
    handleMccInnerSearch() {
      this.searchParams = this.searchForm;
      this.getMccAccountList();
    },
    // 查询 mcc 下的账号
    async getMccAccountList(page = 1) {
      if (this.selectRow.userId) {
        const params = {
          userId: this.selectRow.userId,
          pageNo: page,
          pageSize: this.detailTableList.pagination.pageSize,
          bmOrMcc: this.currentSelectedMcc.customerId
        };
        if (this.searchParams) {
          params["searchKeyWord"] = this.searchParams;
        }
        this.detailTableList.loading = true;
        const res = await ggAccountOfMcc(params);
        this.detailTableList.data = res.data ? res.data.recordList : [];
        this.detailTableList.pagination.total = res.data.recordCount;
        this.detailTableList.pagination.current = res.data.pageNo;
        this.detailTableList.loading = false;
      }
    },
    handleBindNext(values, onlyAccountCheck) {
      this.googleAccountData = {
        ...this.googleAccountData,
        ...values,
        onlyAccountCheck
      };
      this.$refs["accountUnboundStepOne"].visible = false;
      this.$refs["accountUnboundStepTwo"].visible = true;
    },

    handleBindPrevious(values) {
      this.googleAccountData = { ...this.googleAccountData, ...values };
      this.$refs["accountUnboundStepOne"].visible = true;
      this.$refs["accountUnboundStepTwo"].visible = false;
    },
    // 使用expandedRowKeys后变为受控组件，此处的点击收缩行已失效，需要在table上添加expand事件来监听点击展开图标
    expandIcon(props) {
      if (props.expanded) {
        return (
          <a
            onClick={e => {
              props.onExpand(props.record, e);
            }}
            class="expand-cell c-green">
            收起
            <a-icon type="down" class="expand-icon" style="marginLeft: 3px" />
          </a>
        );
      } else {
        return (
          <a
            onClick={e => {
              props.onExpand(props.record, e);
            }}
            class="expand-cell c-green">
            展开
            <a-icon type="right" class="expand-icon" style="marginLeft: 3px" />
          </a>
        );
      }
    },
    // 无用
    handleBind() {
      this.$refs["facebookBindBM"].visible = true;
    }
  },
  mounted() {
    this.getMainTableList()
  }
};
</script>
<style lang="less">
.media-tab {
  position: relative;
  .input-search {
    width: 252px;
  }
  .bind-btn {
    top: -53px;
    position: absolute;
    right: 24px;
  }
  .batch-action {
    margin: 20px 0 10px 0;
  }
  .mb-10 {
    margin-bottom: 10px!important;
  }
  .mr-10 {
    margin-right: 10px!important;
  }
  .mr-5 {
    margin-right: 5px!important;
  }
  .ml-10 {
    margin-left: 10px!important;
  }
  .ml-20 {
    margin-left: 20px!important;
  }
  .fs-20 {
    font-size: 20px;
  }
  .batch-action .title {
    color: rgba(0, 0, 0, 0.85);
    &.mcc {
      display: flex;
      align-items: center;
      .update-mcc-btn, .update-mcc-btn:disabled {
        width: 111px;
        height: 24px !important;
        line-height: 22px !important;
        background: #f4f7f9 !important;
        border-radius: 4px;
        border: 1px solid #e5e8ea;
        font-size: 12px;
        color: #333333 !important;
        line-height: 24px;
        svg {
          font-size: 12px !important;
          cursor: pointer;
        }
        &.update-loading {
          display: flex;
          align-items: center;
          img {
            height: 15px;
          }
        }
      }
      .update-time {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
      }
    }
  }
  .batch-action.inner-search {
    margin: 0 0 10px 0;
  }
  .bm-list-card {
    height: 400px;
    overflow: auto;
    padding: 20px 30px;
    border-left: 1px solid #e1e8f9;
    border-bottom: 1px solid #e1e8f9;
    .ant-list-split .ant-list-item {
      padding: 12px 20px;
      border-radius: 2px;
      border: 1px solid #edf0f7;
      margin-bottom: 10px;
      cursor: pointer;
      &:hover {
        background: #f3f6fe;
      }
      &.selected {
        background: #f2faf3;
        border-color: #22ac35;
      }
      .ant-list-item-meta {
        display: flex;
        align-items: center;
        .ant-list-item-meta-title {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          line-height: 26px;
          margin-bottom: 0;
          text-align: left;
        }
      }
      .role {
        font-size: 12px;
        color: #999999;
      }
    }
  }
  .bm-account-box {
    border-top: 1px solid #e1e8f9;
    .bm-account {
      height: 400px;
      border-right: 1px solid #e1e8f9;
      border-bottom: 1px solid #e1e8f9;
      .bm-bar {
        width: 100%;
        height: 60px;
        background: #f8fafd;
        display: flex;
        align-items: center;
        padding: 12px 20px;
        .account {
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          margin-left: 10px;
        }
        .role {
          font-size: 12px;
          color: #999999;
          margin-left: 30px;
        }
      }
      .table-content {
        border: none;
        padding: 20px;
        height: calc(100% - 60px);
        h4 {
          font-size: 16px;
          color: #333333;
          line-height: 22px;
          text-align: left;
          margin-bottom: 10px;
        }
        // .ant-table {
        //   box-shadow: 0 2px 3px rgba(40, 57, 109, 0.05);
        // }

        .ant-table-pagination.ant-pagination {
          margin-bottom: 0;
        }
      }
    }
    .search-result-box {
      padding: 0 30px 16px;
      &.table-wrap {
        border-top: none;
      }
      .ant-table {
        box-shadow: 0 2px 3px rgba(40, 57, 109, 0.05);
      }
      .line {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
        margin: 10px 0;
        text-align: left;
      }

      .table-cell-bm {
        overflow: hidden;
        white-space: nowrap;
      }
      .more-btn {
        cursor: pointer;
        margin-left: 17px;
        color: #999999;
        &:hover {
          color: #4278ff;
        }
      }
      .ant-table-pagination.ant-pagination {
        margin-bottom: 0;
      }
    }
  }
}
.ant-table:not(.ant-table-fixed-header) .mcc-table-inner .ant-table-placeholder {
  border-right: none;
  border-top: none;
}
.bm-popover {
  .ant-popover-inner-content {
    max-width: 650px;
  }
}
</style>
